export default "__VITE_ASSET__BwpvxUww__"